import { formatFileSize } from 'utils/file';

/** Chromium-only `performance.memory`; omitted from standard `Performance` DOM types. */
type PerformanceWithMemory = Performance & {
  memory?: {
    jsHeapSizeLimit: number;
    totalJSHeapSize: number;
    usedJSHeapSize: number;
  };
};
const chromeHeapMemory =
  typeof window !== 'undefined'
    ? (window?.performance as PerformanceWithMemory)?.memory
    : undefined;

export const getHeapSize = () => ({
  jsHeapSizeLimit: formatFileSize(chromeHeapMemory?.jsHeapSizeLimit ?? 0), // This is the maximum memory limit available for the JavaScript heap.
  totalJSHeapSize: formatFileSize(chromeHeapMemory?.totalJSHeapSize ?? 0), // Memory space currently reserved for JavaScript.
  usedJSHeapSize: formatFileSize(chromeHeapMemory?.usedJSHeapSize ?? 0), // This is the actual memory actively used by your application.
});
